module.exports = __webpack_public_path__ + "static/img/card-contact-location.b1382a8d.png";